(ns ui.view.survey.thank-you-view
  (:require [common.localization :as loc]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]
            [ui.components.ck-editor.view :as ck-editor]
            [ui.tailwind-theme :as tailwind-theme]
            [ui.view.survey.event :as event]
            [ui.view.survey.modals.loading-excel :as loading-excel-modal]
            [ui.view.survey.sub :as sub]))

(defn tesi-esg-thank-you
  [lang]
  (if (= lang :ENG)
    [:<>
     [:p "Thank you for responding to Tesi’s annual impact data request!"]
     [:p "You can download the questionnaire and your submitted answers below."]
     [:p
      {:class "pt-4 mb-4"}
      "We are in touch with the results & aggregated data points at a later date."]]
    [:<>
     [:p "Kiitos, että vastasit Tesin kohdeyrityksille suunnattuun vuosittaiseen vaikuttavuustietopyyntöön!"]
     [:p "Ohesta voit ladata lähettämäsi vastaukset Excel-muodossa."]
     [:p
      {:class "pt-4 mb-4"}
      "Olemme yhteydessä kesän jälkeen tulosten & vertailutietojen osalta."]]))

(defn default-thank-you
  [_lang]
  [:<>
   [:div
    {:class "py-3 flex flex-col gap-3 max-w-[640px] mx-auto mb-4 text-center"}
    [:h2
     {:class "pb-4 block text-2xl font-bold"}
     (loc/tr :thank-you-for-completing-this-survey)]
    [:p
     {:class "md:px-6 block leading-6"}
     (loc/tr :thank-you-for-completing-this-survey-content-text)]]])

(defn view
  [survey-id]
  (let [lang @(rf/subscribe [::sub/selected-lang survey-id])
        access-to-other-surveys? @(rf/subscribe [::sub/access-to-other-surveys?])
        thank-you-texts @(rf/subscribe [::sub/thank-you-texts-localized survey-id])
        theme @tailwind-theme/current-theme]
    [:div
     {:class "px-4 h-screen flex flex-col justify-center items-center container mx-auto"}
     [loading-excel-modal/view survey-id]
     [:span
      {:class "pb-6 flex justify-center text-primary-regular text-8xl"}
      [:i.fa-duotone.fa-solid.fa-circle-check]]
     (cond thank-you-texts
           [:div
            {:class ""}
            [ck-editor/viewer thank-you-texts]]
           (= "teollisuussijoitus" theme)
           [tesi-esg-thank-you lang]
           :else
           [default-thank-you lang])
     [:div
      {:class "mt-5 flex gap-4 flex-col"}
      [:div
       {:class "flex flex-col md:flex-row gap-3"}
       [button/secondary-hollow
        {:class    "min-w-[252px]"
         :on-click #(rf/dispatch [::event/generate-excel survey-id])}
        (loc/tr :download-submitted-answers-as-excel nil lang)]
       (when access-to-other-surveys?
         [button/secondary-hollow
          {:class    "min-w-[252px]"
           :on-click (fn [_]
                       (rf/dispatch [::event/re-select-survey]))}
          (loc/tr :switch-to-another-survey-from-thank-you nil lang)])]
      [button/primary-open
       {:on-click #(rf/dispatch [::event/logout])}
       (loc/tr :exit nil lang)]
      ]]))
